import { createFileRoute } from '@tanstack/react-router';
import { ReportPane } from '@/components/health-readiness/panes';

/** Health & Readiness → Report (T-0242). T-0245 adds the figures. */
export const Route = createFileRoute('/engagements/$engagementId/health-readiness/report')({
  component: ReportRoute,
});

function ReportRoute() {
  const { engagementId } = Route.useParams();
  return <ReportPane engagementId={engagementId} />;
}
